var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[(_vm.isDisplay)?_c('vc-text-contains-link',{attrs:{"replace":{
      ':link': {
        text: 'こちら',
        href: _vm.url,
        target: '_blank'
      }
    }}},[_vm._v(" バリュー版やゴールド会員などの契約状況については:linkからご確認いただけます。 ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }